import { DEBITNOTE_INIT_LOADING, DEBITNOTE_INIT_SUCCESS, DEBITNOTE_INIT_FAIL, DEBITNOTE_LOAD_DATA } from '@/store/types'

export const init = {
  [DEBITNOTE_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [DEBITNOTE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [DEBITNOTE_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [DEBITNOTE_LOAD_DATA] (state, data) {
    state.debitNoteData.branch = data.branch
    state.debitNoteData.accountNo = data.accountNo
    state.debitNoteData.type = data.type
    state.debitNoteData.documentNo = data.documentNo
    state.debitNoteData.fund = data.fund
    state.debitNoteData.suffix = data.suffix
    state.debitNoteData.tranMode = data.tranMode
    state.debitNoteData.currency = data.currency
    state.debitNoteData.amount = data.amount
    state.debitNoteData.gstAmountAE = data.gstAE
    state.debitNoteData.gstAmount = data.gst
    state.debitNoteData.netAmount = data.netAmt
    state.debitNoteData.netLocAmountAE = data.netLocAmtAE
    state.debitNoteData.netLocAmount = data.netLocAmt
    state.debitNoteData.tranDate = data.tranDate
    state.debitNoteData.actionName = data.actionName
    state.debitNoteData.printDoc = data.printDoc
  }
}
